import React from 'react';
import { bemClasses } from '../helpers';
export var CodeComponent = function (_a) {
    var title = _a.title, code = _a.code;
    return (React.createElement("div", { className: bemClasses.element("code") },
        title && (React.createElement("header", { className: bemClasses.element("code-header") },
            React.createElement("h4", null, title))),
        React.createElement("pre", { className: bemClasses.element("code-pre") },
            React.createElement("code", { className: bemClasses.element("code-body") }, code))));
};
//# sourceMappingURL=Code.js.map